import { useTranslation } from 'react-i18next'
import type { AlreadyGotItem } from './types'

interface AlreadyGotSectionProps {
  items: AlreadyGotItem[]
  onClear: () => void
}

export function AlreadyGotSection({ items, onClear }: AlreadyGotSectionProps) {
  const { t } = useTranslation('grocery-list')

  if (items.length === 0) return null

  return (
    <section role="region" aria-label={t('alreadyGot.heading')} className="print:hidden">
      <div className="flex items-center justify-between px-4 py-2">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted">
          {t('alreadyGot.heading')}
        </h2>
        <button
          type="button"
          onClick={onClear}
          aria-label={t('alreadyGot.clearAriaLabel')}
          className="text-xs text-muted hover:text-ink transition-colors"
        >
          {t('alreadyGot.clear')}
        </button>
      </div>
      <div className="px-4">
        {items.map((item) => (
          <div
            key={`${item.name}-${item.quantity}`}
            className="flex items-center gap-3 min-h-[40px] py-1 opacity-60"
          >
            <span className="line-through text-muted text-sm">
              {item.name}
              {item.quantity != null && item.unit ? ` \u2014 ${item.quantity} ${item.unit}` : ''}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
